var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.664 18.333v-15c0-.458.163-.85.49-1.177.326-.326.718-.49 1.177-.49h13.333c.458 0 .85.164 1.177.49.326.327.49.719.49 1.177v10c0 .459-.163.851-.49 1.177-.326.327-.719.49-1.177.49H4.997l-3.333 3.333Zm5.896-6.458 2.437-1.48 2.438 1.48-.646-2.77 2.167-1.876L11.102 7 9.997 4.375 8.893 7l-2.854.23 2.167 1.874-.646 2.771Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiChat);
export default __webpack_public_path__ + "static/media/ai-chat.b817b04358591d9e017cc1759dd28e2c.svg";
export { ForwardRef as ReactComponent };